import { type PropsWithChildren } from 'react'
import { cn } from '../../../utils'

export interface AuftragOptionProps extends PropsWithChildren {
  value: string // used by AuftragOptionen.tsx
  label: string // used by AuftragOptionen.tsx
  isSelected?: boolean
  disabled?: boolean
  readOnly?: boolean
  hasError?: boolean
  className?: string
  'data-testid'?: string
}

export default function AuftragOption({
  children,
  className,
  hasError,
  readOnly,
  disabled,
  'data-testid': testId
}: Readonly<AuftragOptionProps>) {
  const containerClass = cn(className, {
    'focus-within:ring-red-500 ring-2 ring-red-500': hasError,
    'opacity-100 pointer-events-none': readOnly,
    'opacity-40': disabled && !readOnly
  })

  return (
    <div className={containerClass} data-testid={testId}>
      {children}
    </div>
  )
}
